// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/rfi_questions.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
import { RfiExtraction, RfiQuestion, RfiQuestionEvent, RfiQuestionSource, RfiQuestionSuggestion } from "../../datagateway/v1/rfi_questions_pb";
/**
 * @generated from message mono.projectdata.v1.ListRfiQuestionsRequest
 */ export class ListRfiQuestionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiQuestionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiQuestionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiQuestionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiQuestionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiQuestionsRequest, "runtime", proto3);
_define_property(ListRfiQuestionsRequest, "typeName", "mono.projectdata.v1.ListRfiQuestionsRequest");
_define_property(ListRfiQuestionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiQuestionsResponse
 */ export class ListRfiQuestionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiQuestionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiQuestionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiQuestionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiQuestionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RfiQuestion questions = 1;
   */ _define_property(this, "questions", []), /**
   * @generated from field: repeated mono.datagateway.v1.RfiQuestionEvent events = 2;
   */ _define_property(this, "events", []), /**
   * @generated from field: repeated mono.datagateway.v1.RfiExtraction extractions = 3;
   */ _define_property(this, "extractions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiQuestionsResponse, "runtime", proto3);
_define_property(ListRfiQuestionsResponse, "typeName", "mono.projectdata.v1.ListRfiQuestionsResponse");
_define_property(ListRfiQuestionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "questions",
            kind: "message",
            T: RfiQuestion,
            repeated: true
        },
        {
            no: 2,
            name: "events",
            kind: "message",
            T: RfiQuestionEvent,
            repeated: true
        },
        {
            no: 3,
            name: "extractions",
            kind: "message",
            T: RfiExtraction,
            repeated: true
        }
    ]));
/**
 * Manual creation never calls extraction or outline mapping. Source artifact is optional.
 *
 * @generated from message mono.projectdata.v1.CreateRfiQuestionRequest
 */ export class CreateRfiQuestionRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateRfiQuestionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRfiQuestionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRfiQuestionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRfiQuestionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: mono.datagateway.v1.RfiQuestionSource source = 2;
   */ _define_property(this, "source", void 0), /**
   * @generated from field: mono.datagateway.v1.RfiQuestionSuggestion suggestion = 3;
   */ _define_property(this, "suggestion", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRfiQuestionRequest, "runtime", proto3);
_define_property(CreateRfiQuestionRequest, "typeName", "mono.projectdata.v1.CreateRfiQuestionRequest");
_define_property(CreateRfiQuestionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source",
            kind: "message",
            T: RfiQuestionSource
        },
        {
            no: 3,
            name: "suggestion",
            kind: "message",
            T: RfiQuestionSuggestion
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateRfiQuestionResponse
 */ export class CreateRfiQuestionResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateRfiQuestionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRfiQuestionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRfiQuestionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRfiQuestionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiQuestion question = 1;
   */ _define_property(this, "question", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRfiQuestionResponse, "runtime", proto3);
_define_property(CreateRfiQuestionResponse, "typeName", "mono.projectdata.v1.CreateRfiQuestionResponse");
_define_property(CreateRfiQuestionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "question",
            kind: "message",
            T: RfiQuestion
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReviewRfiQuestionRequest
 */ export class ReviewRfiQuestionRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReviewRfiQuestionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewRfiQuestionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewRfiQuestionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewRfiQuestionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string question_id = 2;
   */ _define_property(this, "questionId", ""), /**
   * @generated from field: mono.datagateway.v1.RfiQuestionSuggestion suggestion = 3;
   */ _define_property(this, "suggestion", void 0), /**
   * @generated from field: string answer_state = 4;
   */ _define_property(this, "answerState", ""), /**
   * @generated from field: repeated string section_ids = 5;
   */ _define_property(this, "sectionIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewRfiQuestionRequest, "runtime", proto3);
_define_property(ReviewRfiQuestionRequest, "typeName", "mono.projectdata.v1.ReviewRfiQuestionRequest");
_define_property(ReviewRfiQuestionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "question_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "suggestion",
            kind: "message",
            T: RfiQuestionSuggestion
        },
        {
            no: 4,
            name: "answer_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "section_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReviewRfiQuestionResponse
 */ export class ReviewRfiQuestionResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReviewRfiQuestionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewRfiQuestionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewRfiQuestionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewRfiQuestionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiQuestion question = 1;
   */ _define_property(this, "question", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewRfiQuestionResponse, "runtime", proto3);
_define_property(ReviewRfiQuestionResponse, "typeName", "mono.projectdata.v1.ReviewRfiQuestionResponse");
_define_property(ReviewRfiQuestionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "question",
            kind: "message",
            T: RfiQuestion
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ExtractRfiQuestionsRequest
 */ export class ExtractRfiQuestionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ExtractRfiQuestionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractRfiQuestionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractRfiQuestionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractRfiQuestionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string artifact_id = 2;
   */ _define_property(this, "artifactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractRfiQuestionsRequest, "runtime", proto3);
_define_property(ExtractRfiQuestionsRequest, "typeName", "mono.projectdata.v1.ExtractRfiQuestionsRequest");
_define_property(ExtractRfiQuestionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ExtractRfiQuestionsResponse
 */ export class ExtractRfiQuestionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ExtractRfiQuestionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExtractRfiQuestionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExtractRfiQuestionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExtractRfiQuestionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiExtraction extraction = 1;
   */ _define_property(this, "extraction", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExtractRfiQuestionsResponse, "runtime", proto3);
_define_property(ExtractRfiQuestionsResponse, "typeName", "mono.projectdata.v1.ExtractRfiQuestionsResponse");
_define_property(ExtractRfiQuestionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "extraction",
            kind: "message",
            T: RfiExtraction
        }
    ]));
/**
 * Sets one link idempotently without changing interpretation, review or answer state.
 *
 * @generated from message mono.projectdata.v1.SetRfiQuestionMappingRequest
 */ export class SetRfiQuestionMappingRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetRfiQuestionMappingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetRfiQuestionMappingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetRfiQuestionMappingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetRfiQuestionMappingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string question_id = 2;
   */ _define_property(this, "questionId", ""), /**
   * @generated from field: string section_id = 3;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: bool mapped = 4;
   */ _define_property(this, "mapped", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetRfiQuestionMappingRequest, "runtime", proto3);
_define_property(SetRfiQuestionMappingRequest, "typeName", "mono.projectdata.v1.SetRfiQuestionMappingRequest");
_define_property(SetRfiQuestionMappingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "question_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "mapped",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetRfiQuestionMappingResponse
 */ export class SetRfiQuestionMappingResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetRfiQuestionMappingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetRfiQuestionMappingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetRfiQuestionMappingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetRfiQuestionMappingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiQuestion question = 1;
   */ _define_property(this, "question", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetRfiQuestionMappingResponse, "runtime", proto3);
_define_property(SetRfiQuestionMappingResponse, "typeName", "mono.projectdata.v1.SetRfiQuestionMappingResponse");
_define_property(SetRfiQuestionMappingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "question",
            kind: "message",
            T: RfiQuestion
        }
    ]));
